let Bokeh = require('./bokeh');

module.exports = {
  install (Vue) {
    Vue.directive(Bokeh.directiveName, Bokeh);
  }
};
